<template>
  <div id="contractTable">
    <b-modal id="confirmModal" ref="confirmModal" title="Confirmación" class="">
      <p class="my-2">¿Está seguro que desea anular el contrato?</p>
      <template #modal-footer>
        <b-button  ref="btnDeletefiles" id="btnDeletefiles" class="mt-3" variant="danger" block @click="cancelContract()">Sí, anular</b-button>
        <b-button class="mt-3" block @click="hideModal()">No, cancelar</b-button>
      </template>
    </b-modal>
    <!--Modal contracts -->
    <!--Fin Modal contracts -->
    <b-modal ref="msg_modal" id="msgModal" hide-footer>
      <div id="divMsg" ref="divMsg" class="d-block text-center">
        <h3 v-for="(errorMsg,index) in errorsMsg" :key="index" v-bind:value="errorMsg">{{errorMsg}}</h3>
      </div>
      <b-button class="mt-3" block @click="hideModalMsg()">Cerrar</b-button>
    </b-modal>
    <b-row class="tablaContratos" align-v="center">
      <b-col v-for="(item, index) in tableHeaders" :key="index" @click="headerClick(item)" class="cabeceraTabla" style="text-align:center">
        <i v-if="item.isSortable" :class="sortIcon(item)" aria-hidden="true"></i>
        {{item.name}}
      </b-col>
    </b-row>
    <hr />
    <b-row v-for="(item, index) in tableShowRows" :key="index" v-bind:index="index">
      <b-col>
        <!-- Datos de la tabla -->
        <b-row class="tablaAgencias" :id="'info_' + index" @click="toggleInfo" style="padding-left:20px">
          <template v-for="(header, index2) in tableHeaders">
            <b-col :class="dinamicColor(header,item[header.key])" v-if="isInTableHeaders(header.key)" v-bind:key="index2" style="text-align:center">
              <template :id="'cell_' + index + index2" v-if="isTextCell(header)">{{printCellValue(header.key,item)}}</template>
              <span class="btn_row_table_need">
              <template :id="'cell_' + index + index2" v-if="isButtonCell(header)">
                <button  v-if="header.name != 'Anular'" :id="'btnEditNeed_' + index + index2" :title="header.buttonDownload.title" :disabled="isDownDisabled(item)" @click="downloadCertificate(item)" :class="dinamicColorBtn(item)">
                  <i :class="header.buttonDownload.icon" aria-hidden="true"></i>
                </button>
                <button v-else :id="'btnCancelNeed_' + index + index2" :title="header.buttonCancel.title" :disabled="isCancelDisabled(item)" @click="openModalToCancel(item.id)" :class="dinamiCancelBtn(item)">
                  <i :class="header.buttonCancel.icon" aria-hidden="true"></i>
                </button>
              </template>
              </span>
            </b-col>
          </template>
        </b-row>
        <b-row v-if="tabletMode" class="moreInfoAgency tablaAgencias" :id="'moreinfo_' + index" hidden>
          <template v-for="(header, index3) in tablePCHeaders">
            <template v-if="!isInTableHeaders(header.key)">
              <b-col cols="12" :key="index3">
                <b-row >
                  <b-col cols="6" >{{header.name}}</b-col>
                  <template :id="'cell_' + index + index3" v-if="isTextCell(header)">{{printCellValue(header.key,item)}}</template>
                  <template :id="'cell_' + index + index3" v-if="isButtonCell(header)">
                    <button v-if="header.name != 'Anular' " :id="'btnEditNeed_' + index + index3" :title="header.buttonDownload.title" :disabled="isDownDisabled(item)" @click="downloadCertificate(item)" :class="dinamicColorBtn(item)">
                      <i :class="header.buttonDownload.icon" aria-hidden="true"></i>
                    </button>
                    <button v-else :id="'btnCancelNeed_' + index + index3" :title="header.buttonCancel.title" :disabled="isCancelDisabled(item)" @click="openModalToCancel(item.id)" :class="dinamiCancelBtn(item)">
                      <i :class="header.buttonCancel.icon" aria-hidden="true"></i>
                    </button>
                  </template>
                </b-row>
              </b-col>
            </template>
          </template>
        </b-row>
        <hr />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import constants from '@/assets/environments/constants'
export default {
  name: 'contracts-table',
  props: {
    value: Array,
    itemsPerPage: {
      type: Number,
      default: constants.contractTableDefaultSize
    },
    pageIndex: {
      type: Number,
      default: constants.contractTableDefaultPage
    },
    tabletMode: {
      type: Boolean,
      default: false
    },
  },
  data(){

    return {
      popup: false,
      tableRows: this.value,
      tablePCHeaders: [],
      tableTabletHeaders: [],
      sortStates: [],
      token:'',
      payload:{ id:'' },
      filterStatusOptions: [],
      errorsMsg:[],
      id_contract_to_cancel:'',
      isAdmin:false,
      isSocial:false
    }
  },
  computed: {
    tableHeaders() {
      return this.tabletMode ? this.tableTabletHeaders : this.tablePCHeaders;
    },
    tableShowRows(){
      let begin = (this.pageIndex -1) * this.itemsPerPage;
      return this.value.slice(begin, begin + this.itemsPerPage);
    }
  },
  created() {
    this.token = this.$session.get("token")
    this.initTableHeaders()
    this.initSortStates()
    this.refactorEnv = this.$session.get("settings")
  },
  methods: {
    initTableHeaders() {
      var self  = this;
      this.tablePCHeaders = []
      this.tableTabletHeaders = []
      var headers = this.$constants.contractTableHeaders;
      var rol = this.$session.get('rol')
      if (rol == constants.roleSuperAdmin) {
          this.isAdmin = true;
        }
      headers.forEach(function(value, index, array) {
        var isRoleFiltered = false;
        var isTabletFiltered = value.hideInTablet;

        if (!isRoleFiltered) {
          self.tablePCHeaders.push(value);

          if (!isTabletFiltered) {
            self.tableTabletHeaders.push(value);
          }
        }

      });
    },
    isInTableHeaders(key){
      return this.tableHeaders.find(o=>{ return o.key == key}) != undefined;
    },
    toggleInfo(event){
      if(this.tabletMode){
        let element = document.getElementById('more' + event.currentTarget.id);
        if (element.hasAttribute('hidden')) {
          element.removeAttribute('hidden');
        } else {
          element.setAttribute('hidden', true);
        }
      }
    },
    printCellValue(key, value){
      if(key == 'social' && (value[key] == 'undefined' || value[key] == '' || value[key] == null ) ){
        return value['name']}
      else{return value[key]}
    },
    initSortStates() {
      var self = this
      var headers = this.$constants.contractTableHeaders;
      headers.forEach(function(value, index, array) {
        if (value.isSortable) {
          self.sortStates.push({'key': value.key, 'pos': index, 'state': undefined})
        }
      });
    },
    sortIcon(item) {
      var colState = this.sortStates.filter(obj => { return obj.key === item.key})[0];
      switch(this.sortStates[colState.pos].state) {
        case 'asc':   return 'fa fa-sort-asc'
        case 'desc':  return 'fa fa-sort-desc'
        default:      return 'fa fa-sort'
      }
    },
    headerClick(header) {
      if (header.isSortable) {
        var colState = this.sortStates.filter(obj => { return obj.key === header.key})[0];
        switch(colState.state) {
          case undefined:
          case null:
          case 'asc': this.sortStates[colState.pos].state = 'desc'; break;
          default: this.sortStates[colState.pos].state = 'asc';  break;
        }
        var currSortState = this.sortStates[colState.pos];
        this.value.sort(function (item1, item2) {
          var key = currSortState.key
          var state = currSortState.state
          var param1 = item1[key]
          var param2 = item2[key]
          if(header.key== 'id'){
            param1 = parseInt(param1)
            param2 = parseInt(param2)
          }
          if(header.columnType == 'date' ){
            var expresionRegular = new RegExp(/\/|\-/)
            if(param1 != null && param1 != ""){
              var dateParts1 = param1.split(expresionRegular)
              param1 = new Date(+dateParts1[2], dateParts1[1], +dateParts1[0])}
            if(param2 != null && param2 != ""){
              var dateParts2 = param2.split(expresionRegular)
              param2 = new Date(+dateParts2[2], dateParts2[1], +dateParts2[0])}
          }else if(header.columnType == 'object'){
            param1 = param1.code
            param2 = param2.code
          }
          if ( param1 < param2 || param1 == null){
            return state == 'desc' ? -1 : 1;
          }
          if (  param1 > param2 || param2 == null){
            return state == 'desc' ? 1 : -1;
          }
          return 0;
        })
        this.$emit('input', this.value)
      }
    },
    isTextCell(header) {
      return header.columnType != 'button'
    },
    isButtonCell(header) {
      return header.columnType == 'button'
    },
    async downloadCertificate(item){
      this.payload.id = item.id
      this.errorsMsg = []
      await this.$http.post(this.refactorEnv.downloadCertificate,this.payload,{headers: {'Authorization': this.token}},{responseType: 'blob'}
      ).then(response =>(
        this.downloadContractPdf(response.data)
      )).catch((error) =>{
        this.getMsg(constants.error_download_cert)
      })
    },
    downloadContractPdf(response){
      const link = document.createElement('a');
      link.href = 'data:application/pdf;base64,' + response.pdf_file;
      link.setAttribute('download', response.name);
      document.body.appendChild(link);
      link.click();
    },
    async buildStatusSelector() {
      await this.$http.post(this.refactorEnv.getStatusList,{}, { headers: {
        'Authorization': this.token
      }}).then(response => {
        var aux = []
        response.body.status_list.forEach(function(value, index, array){
          aux.push({ "value" : value.Id,"text":value.Estado })
        });
        this.filterStatusOptions = aux;
      }).catch(error => {console.log(error)});
    },
    closeEditModal(){
      this.$bvModal.hide('editNeedModal')
    },
    hideModalMsg(){
      this.$bvModal.hide('msgModal')
    },
    getMsg(error){
      this.$bvModal.show('msgModal')
      this.errorsMsg.push(error)
      this.closeEditModal()
    },
    dinamicColor(column, value){
      var list_css_class = 'datosTabla'
      var status = constants.status_list
      if(column.key == constants.need_status || column.key == constants.doc_status){
        for(var element in status ){if(value == element){list_css_class = list_css_class+' '+status[element]}}
      }
      if(column.key == constants.action_download_column_contracts || column.key == constants.action_cancel_column_contracts){
        list_css_class = list_css_class+' centerIcons'
      }
      return list_css_class
    },
    openModalToCancel(id_contract){
      this.id_contract_to_cancel = id_contract
      this.$refs['confirmModal'].show()
    },
    hideModal() {
      this.id_contract_to_cancel = ''
      this.$refs['confirmModal'].hide()
    },
    dinamicColorBtn(item){
      var list_css_class = 'tableIconBtn tableIconBtnFloat'
      if(item.contract_status_id != constants.contract_signed_id ){
        list_css_class = list_css_class+' disabledDownloadIcon'
      }
      return list_css_class
    },
    isDownDisabled(item){
      var disabled = false
      if(item.contract_status_id != constants.contract_signed_id){disabled = true}
      return disabled
    },
    validNif(dni){
      this.isSocial = false
      var expresion_regular_cif = /^[a-zA-Z]{1}\d{7}[a-zA-Z0-9]{1}$/;
      if(expresion_regular_cif.test (dni)){ this.isSocial = true }
      return this.isSocial
    },
    async cancelContract(){
      var payload = {'id':this.id_contract_to_cancel}

      await this.$http.post(this.refactorEnv.cancelContract,payload, { headers: {
        'Authorization': this.token
      }}).then(response => {
        this.$emit('on-filter-click')
      }).catch(error => {console.log(error)});
      this.hideModal()
    },
    isCancelDisabled(item){
      var disabled = false
      if(item.contract_status_id != constants.contract_pending_id){disabled = true}
      return disabled
    },
    dinamiCancelBtn(item){
      var list_css_class = 'tableIconBtn tableIconBtnFloat'
      if( item.contract_status_id != constants.contract_pending_id){
        list_css_class = list_css_class+' disabledDownloadIcon'
      }
      return list_css_class
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/contracts-table.vue